import type { SearchCriteria } from '../../Search/SearchCriteria.csharp';
import type { QueryParameter } from '../SearchBase/QueryParameterUtils';
import type { SelectedFacet } from '~/Features/Search/SelectedFacet.csharp';

export type ConversionFunction = (item: QueryParameter) => QueryParameter;

export const phraseParameterName = 'phrase';

export const getBaseSearchQueryParameters = (searchParams: SearchCriteria) => {
    const initialArray: QueryParameter[] = searchParams.phrase
        ? [{ name: phraseParameterName, value: searchParams.phrase }]
        : [];

    const convertToQueryParameter = (name: string, value: string) => ({ name, value });

    const combineIntoQueryParameters = (currentValue: QueryParameter[], facet: SelectedFacet) => [
        ...currentValue,
        ...facet.values.map(facetValue => convertToQueryParameter(facet.id, facetValue)),
    ];

    return searchParams.selectedFacets
        .filter(facet => facet.values.length > 0)
        .reduce(combineIntoQueryParameters, initialArray);
};
